import React, { useState, useEffect, useCallback } from 'react';
import './Gallery.css';

const IMAGE_BASE = process.env.PUBLIC_URL;

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    `${IMAGE_BASE}/images/optimized/DJI_0587.jpg`,
    `${IMAGE_BASE}/images/optimized/DJI_0590.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091269.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091278.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091293.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091344.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091354.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091561.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091574.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091583.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091587.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091589.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091592.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091597.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091603.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091613.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091616.jpg`,
    `${IMAGE_BASE}/images/optimized/P1091629.jpg`,
  ];

  const openLightbox = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const prevImage = useCallback((e) => {
    if (e) e.stopPropagation();
    const newIndex = (currentIndex - 1 + images.length) % images.length;
    setCurrentIndex(newIndex);
    setSelectedImage(images[newIndex]);
  }, [currentIndex, images]);

  const nextImage = useCallback((e) => {
    if (e) e.stopPropagation();
    const newIndex = (currentIndex + 1) % images.length;
    setCurrentIndex(newIndex);
    setSelectedImage(images[newIndex]);
  }, [currentIndex, images]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') prevImage(e);
      else if (e.key === 'ArrowRight') nextImage(e);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, currentIndex, prevImage, nextImage]);

  return (
    <section id="gallery" className="gallery-section">
      <div className="container">
        <div className="welcome-text">
          <p>
            Dobro došli u Odmaralište HANA – vašu oazu mira, zabave i uživanja u srcu netaknute prirode!
          </p>
          <p>
            Idealno za porodična okupljanja, rođendane, proslave, team buildinge, sportske dane, reakreaciju i druženja sa prijateljima.
          </p>
          <p>
            Na raspolaganju su vam bazen, vanjski i unutrašnji tuš, jakuzi, sauna (u izgradnji), el. roštilj u objektu, pečenjara, stoni tenis, pikado, dječji tereni za fudbal, košarka, odbojka, badminton, trampolina, vrteška, tobogan, klackalica i još mnogo sadržaja za savršen dan u prirodi. Uživajte u opuštajućem ambijentu daleko od gradske gužve, a samo 4km od centra grada Tuzle, gdje svaka minuta donosi osmijeh, relaksaciju i nezaboravne trenutke.
          </p>
          <p>
            Odmaralište HANA – mjesto gdje mir i uživanje postaju stil života. Rezervišite svoj termin i stvorite uspomene koje traju!
          </p>
        </div>

        <h2 className="section-title">Galerija</h2>
        <div className="gallery-grid">
          {images.map((image, index) => (
            <div
              key={index}
              className="gallery-item"
              onClick={() => openLightbox(image, index)}
            >
              <img src={image} alt={`Fotografija ${index + 1}`} loading="lazy" />
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <span className="close-btn">&times;</span>
          <span className="nav-btn prev-btn" onClick={prevImage}>&#10094;</span>
          <div className="lightbox-content">
            <img src={selectedImage} alt="Uvećani prikaz" />
          </div>
          <span className="nav-btn next-btn" onClick={nextImage}>&#10095;</span>
        </div>
      )}
    </section>
  );
};

export default Gallery;
